import { html } from 'fxjs/es';

export const fn = ({ img }) => html` <div class="pd-zoom">${img}</div> `;
